import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  btn: {
    marginBottom: '16px',
    padding: '16px 22px',
    fontSize: '1rem',
    borderRadius: '0px',
    textTransform: 'none',
    '& svg,img': {
      marginInlineEnd: theme.spacing(1),
    },
  },
  btnPrimary: {
    background: theme.palette.primary.white,
    color: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  btnSecondary: {
    color: theme.palette.primary.adgmBlack,
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    // '&:hover': {
    //   background: theme.palette.primary.acscent,
    // },
  },
  btnDim: {
    background: '#CED1D6',
    color: theme.palette.primary.darkGrey,
    '&:hover': {
      background: '#ced1d6cc',
    },
  },
  btnGreen: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },
  btnDefault: {
    border: '1px solid' + theme.palette.primary.acscent,
    color: theme.palette.primary.acscent,
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },
  fullWidth: {
    width: '100%',
  },
}));

const AuroraButton = ({ variant, fullwidth, className, children, ...props }) => {
  const classes = useStyles();

  const getClasses = () => {
    if (variant === 'primary') {
      return [classes.btn, classes.btnPrimary];
    }
    if (variant === 'secondary') {
      return [classes.btn, classes.btnSecondary];
    }
    if (variant === 'dim') {
      return [classes.btn, classes.btnDim];
    }
    if (variant === 'green') {
      return [classes.btn, classes.btnGreen];
    }
    return [classes.btn, classes.btnDefault];
  };

  return (
    <Button {...props} className={classnames([...getClasses(), fullwidth ? classes.fullWidth : '', className])}>
      {children}
    </Button>
  );
};

AuroraButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'default', 'dim', 'green']),
  fullwidth: PropTypes.bool,
};

AuroraButton.defaultProps = {
  className: '',
  variant: 'default',
  fullwidth: false,
};

export default AuroraButton;
